enum LoggerType {
    INFO,
    WRAN,
    ERROR,
}

export class Logger {
    private static message: string = '';
    private static date: Date = new Date();
    private static event: string = '';

  
    public static logInfo (comp: string, msg: string): void {
        this.setMessage(comp, msg);
        this.printMessage(LoggerType.INFO);
    }
    
    public static logWran (comp: string, msg: string): void {
        this.setMessage(comp, msg);
        this.printMessage(LoggerType.WRAN);
    }

    public static logError (comp: string, msg: string): void {
        this.setMessage(comp, msg);
        this.printMessage(LoggerType.ERROR);
    }

    private static setMessage (comp: string, msg: string): void {
        this.message = `[${comp} ${this.formatDateTime(this.date)}] ${msg}`;
    }

    private static formatDateTime (date: Date) : string {
        return `${new Intl.DateTimeFormat("th-TH", {dateStyle: "full",}).format(date)} ${date.toLocaleTimeString("th-TH", {hour: "2-digit", minute: "2-digit" })}`
    }

    private static printMessage (logType: LoggerType) : void {
        switch (logType) {
            case LoggerType.ERROR: 
                console.error(this.message);
                break;
            case LoggerType.WRAN:
                console.warn(this.message);
                break;
            default:
                console.log(this.message);
                break;
        }
    }
  }